import { REGROUPEMENT } from '@/configuration/devisConf';

export default function genererCritereRecherchePrevisionnel() {
  return {
    auto: '',
    societeId: null,
    agencesIdProduit: [],
    logisticable: true,
    aIntegrerDansLaLogistique: true,
    sens: '',
    nePasReafficher: true,
    types: [REGROUPEMENT],
    typesProduits: [],
    datesPrevisionnelDepart: {
      dateDebut: null,
      dateFin: null,
    },
    bloqueOuInterne: true,
    typesDevisCommandeFacture: [],
  };
}
